import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import * as dashTypes from 'store/modules/dash/mutation-types'

let sendApprove = function ({ dataRows, sendApprove, dispatch, dispatchType }) {
  let filterIndexRows = {}
  let row = 0
  let approveRow = 0
  let rejectRow = 0
  for (var i = 0; i < dataRows.length; i++) {
    if (typeof dataRows[i].flgStaappr !== 'undefined' && dataRows[i].flgStaappr !== 'P' && dataRows[i].flgStaappr.trim() !== '') {
      row++
      if (dataRows[i].flgStaappr === 'A') {
        approveRow++
      } else if (dataRows[i].flgStaappr === 'N') {
        rejectRow++
      }
      filterIndexRows[row - 1] = {
        p_staappr: (typeof dataRows[i].flgStaappr !== 'undefined') ? dataRows[i].flgStaappr : '',
        p_approvno: (typeof dataRows[i].approvno !== 'undefined') ? dataRows[i].approvno : '',
        p_chk_appr: (typeof dataRows[i].chk_appr !== 'undefined') ? dataRows[i].chk_appr : '',
        p_numseq: (typeof dataRows[i].numseq !== 'undefined') ? dataRows[i].numseq : '',
        p_codempid: (typeof dataRows[i].codempid !== 'undefined') ? dataRows[i].codempid : '',
        p_dtereq: (typeof dataRows[i].dtereq !== 'undefined') ? dataRows[i].dtereq : '',
        p_dtereqr: (typeof dataRows[i].dtereqr !== 'undefined') ? dataRows[i].dtereqr : '',
        p_dtework: (typeof dataRows[i].dtework !== 'undefined') ? dataRows[i].dtework : '',
        p_batchno: (typeof dataRows[i].dtework !== 'undefined') ? dataRows[i].batchno : '',
        p_seq: (typeof dataRows[i].dtework !== 'undefined') ? dataRows[i].seq : '',
        p_typ: (typeof dataRows[i].typ !== 'undefined') ? dataRows[i].typ : ''
      }
    }
  }
  if (row > 0) {
    let domRemarkApprove = '<textarea id="remark-approve" class="form-control" maxlength="500"></textarea>'
    let domRemarkReject = '<textarea id="remark-reject" class="form-control" maxlength="500"></textarea>'
    let domRemark = ''
    domRemark += '<div class="swal-approve-remark">'
    domRemark += '  <div class="content-header">'
    domRemark += (approveRow > 0) ? '<div class="item-header">' + 'Remark for Approve' + '</div>' + domRemarkApprove : ''
    domRemark += (rejectRow > 0) ? '<div class="item-header">' + 'Remark for Reject' + '</div>' + domRemarkReject : ''
    domRemark += '  </div>'
    domRemark += '  <div class="content-summary text-skin">'
    domRemark += (approveRow > 0) ? '<div class="item-summary">' + 'No. of Approve' + ' ' + approveRow + ' ' + 'records' + '</div>' : ''
    domRemark += (rejectRow > 0) ? '<div class="item-summary">' + 'No. of Reject' + ' ' + rejectRow + ' ' + 'records' + '</div>' : ''
    domRemark += '  </div>'
    domRemark += '</div>'

    swal({
      title: 'Confirmation',
      text: domRemark,
      showCancelButton: true,
      closeOnConfirm: false,
      closeOnCancel: true,
      html: true
    },
    function (isConfirm) {
      if (isConfirm) {
        let sendParams = {
          param_json: JSON.stringify(filterIndexRows),
          remarkApprove: (approveRow > 0) ? document.getElementById('remark-approve').value : '',
          remarkReject: (rejectRow > 0) ? document.getElementById('remark-reject').value : ''
        }
        swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
        sendApprove(sendParams)
          .then((response) => {
            const data = JSON.parse(response.request.response)
            swal({
              title: '', text: data.response || data.data.response, type: 'success'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
            dispatch(dispatchType, {})
            dispatch(dashTypes.RECEIVED_HEADER_NOTI_TOTAL, 'P,Y,N,A')
          })
          .catch((error) => {
            let message = error
            if (error.response) {
              const data = error.response.data
              message = data.response
            }
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          })
      }
    })
  } else {
    swal({
      title: 'Confirmation',
      text: 'Please select at least 1 record.'
    }, function () {
      window.onkeydown = null; window.onfocus = null; swal('')
    })
  }
}

export { sendApprove }



// WEBPACK FOOTER //
// ./src/assets/js/sendApprove.js